import React from "react";
import { FaVideo } from "react-icons/fa";

const TaggfilmerLogo = () => <FaVideo color="black" size={"40px"} />;

export default TaggfilmerLogo;